import { render, staticRenderFns } from "./listing-statistics-new.vue?vue&type=template&id=c0c4c1f2&scoped=true&"
import script from "./listing-statistics-new.vue?vue&type=script&lang=js&"
export * from "./listing-statistics-new.vue?vue&type=script&lang=js&"
import style0 from "./listing-statistics-new.vue?vue&type=style&index=0&id=c0c4c1f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c4c1f2",
  null
  
)

export default component.exports